import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  customizeIconBox: (isActive: boolean, bg: string) => ({
    display: 'flex',
    alignItems: 'center',
    bg,
    border: `0.5px dashed ${theme.rawColors.dashColor}`,
    borderRadius: '40px',
    position: 'relative',
    zIndex: theme.zIndex.documentHigh,
    height: ['32px', '32px', '32px', '40px'],
    padding: ['7px 7px 7px 6px', '7px 7px 7px 6px', '7px 7px 7px 6px', '10px 10px 10px 9px'],
    width: isActive ? ['32px', '32px', '32px', '100%'] : ['32px', '32px', '32px', '40px'],
    ...reusables.mainTransition('width', theme.transitions.animation.atomCurve, theme.transitions.time.fast),
    'span svg': {
      width: [18, 18, 18, 22],
      height: [18, 18, 18, 22]
    },
    p: {
      color: theme.rawColors.darkGrey700,
      textTransform: 'capitalize',
      pl: ['4px', '4px', '4px', '8px'],
      fontSize: theme.fontSizes.smallText,
      overflowX: 'hidden',
      width: isActive ? [0, 0, 0, '100%'] : '0%',
      '&:hover': {
        color: theme.rawColors.darkGrey700
      },
      ...reusables.mainTransition('width')
    }
  })
};